import { gqlRequest } from './api';

export const addressService = {
  async getAddresses({ offset = 0, limit = 10, query, id, filters, requiredLicense, includeCompany } = {}) {
    const data = await gqlRequest(`
      query UserAddresses(
        $offset: Int, $limit: Int, $query: String,
        $id: Int, $filters: String,
        $requiredLicense: Boolean, $includeCompany: Boolean
      ) {
        userAddresses(
          offset: $offset, limit: $limit, query: $query,
          id: $id, filters: $filters,
          requiredLicense: $requiredLicense, includeCompany: $includeCompany
        ) {
          count
          offset
          limit
          addresses {
            id
            items { id attributeCode groupCode value }
          }
        }
      }
    `, { offset, limit, query, id, filters, requiredLicense, includeCompany },
    { requireAuth: true });

    const result = data.userAddresses;
    return {
      ...result,
      addresses: (result.addresses || []).map(transformAddress)
    };
  },

  async saveAddress(address) {
    const data = await gqlRequest(`
      mutation SaveAddress($address: AddressInput!) {
        saveAddress(address: $address) {
          id
          street
          complement
          city
          state
          country
          postalCode
          defaultBilling
          defaultShipping
        }
      }
    `, {
      address: {
        id: address.id || undefined,
        street: address.street,
        complement: address.apt || address.complement || '',
        city: address.city,
        state: address.state,
        country: address.country || 'US',
        postalCode: address.zip || address.postalCode,
        defaultShipping: address.defaultShipping !== false,
        defaultBilling: address.defaultBilling !== false
      }
    },
    { requireAuth: true });

    return data.saveAddress;
  },

  async deleteAddress(id) {
    const data = await gqlRequest(`
      mutation DeleteAddress($id: ID!) {
        deleteAddress(id: $id)
      }
    `, { id },
    { requireAuth: true });

    return data.deleteAddress;
  }
};

function transformAddress(apiAddress) {
  if (!apiAddress) return null;

  const fields = {};
  if (apiAddress.items) {
    for (const item of apiAddress.items) {
      fields[item.attributeCode] = item.value;
    }
  }

  return {
    id: apiAddress.id,
    street: fields['address-street'] || '',
    apt: fields['address-complement'] || '',
    city: fields['address-city'] || '',
    state: fields['address-region-code'] || fields['address-state'] || '',
    zip: fields['address-postcode'] || '',
    country: fields['address-country-id'] || fields['address-country'] || 'US',
    company: fields['address-company'] || '',
    firstName: fields['address-firstname'] || '',
    lastName: fields['address-lastname'] || '',
    phone: fields['address-phone'] || '',
    email: fields['address-email'] || '',
    alias: fields['address-alias'] || '',
    npi: fields['npi'] || '',
    licenseNumber: fields['license-number'] || '',
    defaultShipping: fields['address-defaultShipping'] === 'true',
    defaultBilling: fields['address-defaultBilling'] === 'true',
    _raw: apiAddress
  };
}
